import RecentProjects from '../../components/RecentProjects/RecentProjects';
/*import { getActionByProjectType } from '../../actionMap'; */
import Layout from '../../components/Layout/Layout';
import './Home.scss';
import { Container } from '@mui/material';

const Home = () => {
    /*     const { cleanProject } = getActionByProjectType(); */

    /* dispatch(cleanProjectInfo()); */
    /*     dispatch(cleanProject()); */

    return (
        <Layout>
            <Container>{<RecentProjects />}</Container>
        </Layout>
    );
};

export default Home;
